import React from "react";
import ChecklistCatalog from "../../components/checklist/ChecklistCatalog";

export default function NurseChecklist() {
  return <ChecklistCatalog type="nurse" />;
}
